import { render, staticRenderFns } from "./BooksHeader.vue?vue&type=template&id=695d6b89&scoped=true&"
import script from "./BooksHeader.vue?vue&type=script&lang=js&"
export * from "./BooksHeader.vue?vue&type=script&lang=js&"
import style0 from "./BooksHeader.vue?vue&type=style&index=0&id=695d6b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d6b89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VIcon,VTextField})
